module.exports = __webpack_public_path__ + "img/banner-agen.e7988671.jpg";